import type { SimulationDef } from "./types";

// The shipped demo scenario (examples/demo.json), inlined verbatim: a guaranteed-valid
// starting point for a new definition. "Open a copy" from the library replaces it.
export const STARTER_DEFINITION: SimulationDef = {
  "name": "demo",
  "seed": 42,
  "space": {
    "kind": "graph",
    "topology": {
      "generator": "ring",
      "n": 8
    },
    "position_component": "node",
    "perception_radius": 0
  },
  "components": [
    {
      "name": "node",
      "kind": "array",
      "dtype": "int64",
      "fill": 0,
      "double_buffered": true,
      "object_kind": null,
      "capacity": null
    },
    {
      "name": "energy",
      "kind": "array",
      "dtype": "float64",
      "fill": 1.0,
      "double_buffered": true,
      "object_kind": null,
      "capacity": null
    }
  ],
  "fields": [],
  "item_types": [],
  "agents": {
    "count": 20,
    "placement": [
      {
        "name": "place_modulo",
        "params": {
          "component": "node"
        }
      }
    ]
  },
  "actions": [
    {
      "verb": "IDLE",
      "eligible": {
        "name": "always"
      },
      "effect": [
        {
          "name": "noop"
        }
      ],
      "considerations": [],
      "base_weight": 1.0,
      "build_params": null,
      "duration": 1,
      "interruptible": true,
      "tick_effect": []
    },
    {
      "verb": "MOVE",
      "eligible": {
        "name": "always"
      },
      "effect": [
        {
          "name": "move_to_param",
          "params": {
            "param": "dest"
          }
        }
      ],
      "considerations": [],
      "base_weight": 1.0,
      "build_params": null,
      "duration": 1,
      "interruptible": true,
      "tick_effect": []
    }
  ],
  "world_systems": [
    {
      "name": "scale_component",
      "params": {
        "component": "energy",
        "factor": 0.999
      }
    }
  ],
  "perception": [],
  "metrics": [],
  "policy": {
    "kind": "stub",
    "params": {
      "move_probability": 0.5
    }
  },
  "arbitrator": {
    "kind": "passthrough",
    "params": {}
  },
  "execution": null,
  "lifecycle": null
};
